import VideoPlayerMeta from './VideoPlayerMeta'

export default VideoPlayerMeta
// eslint-disable-next-line import/export
export * from './VideoPlayerMeta'
